import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {AtendimentoModule} from "./atendimento/atendimento.module";
import {ClienteModule} from "./cliente/cliente.module";
import {PessoaModule} from "./pessoa/pessoa.module";
import {IndexComponent} from "./gerais/index/index.component";

const routes: Routes = [
  {
    path: 'gerais',
    component: IndexComponent,
  },
  {
    path: 'atendimento',
    loadChildren: () => AtendimentoModule
  },
  {
    path: 'cliente',
    loadChildren: () => ClienteModule
  },
  {
    path: 'pessoa',
    loadChildren: () => PessoaModule
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CadastroRoutingModule { }
